
  import { defineComponent, PropType } from 'vue';

  import { TStatisticsPortalFilter } from '../../../types/statistics/statistics-portal';
  import StatisticsViewsCountTabs from '../StatisticsViewsCountTabs.vue';
  import StatisticsPortalViewsCountByNavigationTab from './StatisticsPortalViewsCountByNavigationTab.vue';
  import StatisticsPortalViewsCountByTimeTab from './StatisticsPortalViewsCountByTimeTab.vue';

  export default defineComponent({
    name: 'StatisticsPortalViewsCountTabs',
    components: {
      StatisticsViewsCountTabs,
      StatisticsPortalViewsCountByNavigationTab,
      StatisticsPortalViewsCountByTimeTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPortalFilter>,
        required: true,
      },
    },
  });
